/**
 * @param {Object} map key/value pair of widget name on backend to widget path on frontend
 * @returns {Object} key/value pair of widget name on backend to widget component object
 */
export default (map) => {
  const importMap = {};
  for (const [resultType, componentPath] of Object.entries(map)) {
    // webpack does static analysis at build time, at such passing
    // a variable to dynamic import / require leads to an error where webpack
    // does not know how to resolve our components
    // https://github.com/webpack/webpack/issues/6680#issuecomment-370800037
    // Solution is to manually construct each component path, by hardcoding
    // parts of the component path, making static analysis possible

    // strip out '~/'
    const modifyWidgetPath = componentPath.replace('~/', '');
    // hardcode '~/' and file type (.vue) at the end.
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const component = require(`~/${modifyWidgetPath}.vue`).default;
    // NOTE: require() (sync) is favored over import() (async) here because
    // these components need to be fed into the mixins before component render.
    importMap[resultType] = component;
  }
  return importMap;
};
